// Toast.js
import React, { useEffect, useState } from 'react';
import * as styles from './Toast.module.css';

/**
 * Toast component that displays a message and disappears after a given duration.
 *
 * @param {Object} props - The props object.
 * @param {string} props.message - The message to display.
 * @param {number} [props.duration=3000] - Duration (in milliseconds) before the toast disappears.
 * @param {function} props.onClose - Callback invoked when the toast disappears.
 * @returns {React.Element|null} A toast component or null.
 */
const Toast = ({ message, duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);
  const [isRendered, setIsRendered] = useState(true);
  useEffect(() => {
    const fadeDuration = 300; // duration for the fade effect in milliseconds

    const visibilityTimer = setTimeout(() => {
      setVisible(false);
    }, duration - fadeDuration);

    const renderTimer = setTimeout(() => {
      setIsRendered(false);
      onClose && onClose();
    }, duration);

    return () => {
      clearTimeout(visibilityTimer);
      clearTimeout(renderTimer);
    };
  }, [duration, onClose]);

  if (!isRendered) return null;

  return (
    <div className={`${styles.root} ${!visible ? styles.fadeOut : ''}`}>
      {message}
    </div>
  );
};

export default Toast;
